/**
 * Determine access to Reports Resources from authClient permissions
 *
 * @param permissions
 * @param any
 * @param only
 * @param also
 * @return {boolean}
 */
export const resolveAccess = (permissions, any = [], only = [], also = []) => {
    if (permissions) {
        // Note lists of optional (any), specific (only), or additional (also) against permissions
        const anyLength = any.length;
        const onlyLength = only.length;
        const alsoLength = also.length;

        // Permissions might be an array or a string
        const permissionsIsArray = (typeof permissions !== 'string');

        // Check specific permissions (used for displaying limited content to users with less access):
        if (onlyLength) {
            for (let o = 0; o < onlyLength; o++) {
                if (permissionsIsArray) {
                    if (permissions.findIndex(p => p === only[o]) !== -1) {
                        return true;
                    }
                } else {
                    if (permissions === only[o]) {
                        return true;
                    }
                }
            }
            // Do not display for any user except for specified permission
            return false;
        }

        // If permissions equals a string:
        // (Sysops, Sysadmins, Users with sections_all, Users with section: reports may always access)
        if (
            permissions === 'sys_op' || permissions === 'sys_admin' ||
            permissions === 'sections_all' ||
            (permissions === 'reports' && !alsoLength)
        ) {
            return true;
        }

        if (!anyLength && !onlyLength && !alsoLength) {
            // If only permissions is provided, Users with section: reports may access
            if (permissionsIsArray) {
                if (permissions.findIndex(p => p === 'reports') !== -1) {
                    return true;
                }
            } else {
                if (permissions.indexOf('reports') !== -1) {
                    return true;
                }
            }
        }

        // If any permission matches requested access:
        if (anyLength) {
            for (let j = 0; j < anyLength; j++) {
                if (permissionsIsArray) {
                    if (permissions.findIndex(p => p === any[j]) !== -1) {
                        return true;
                    }
                } else {
                    if (permissions === any[j]) {
                        return true;
                    }
                }
            }
        }

        // If an additional permission beyond "reports" requested access:
        if (alsoLength) {
            for (let a = 0; a < alsoLength; a++) {
                const sections = localStorage.getItem('sections');
                if (sections && sections.includes(also[a])) {
                    return true;
                }
            }
        }
    }
    return false;
};

/**
 * Determine if user has Reports access via user role or permissions
 *
 * @returns {boolean}
 */
export const hasReportsAccess = () => {
    const opOrAdmin = isSysopOrSysadmin();
    const sectionsAll = localStorage.getItem('sections_all');
    const userSections = JSON.parse(localStorage.getItem('sections'));
    return !!(opOrAdmin ||
        sectionsAll === 'true' ||
        (userSections && userSections.includes('reports'))
    );
};

/**
 * Determine if user is sysop or sysadmin
 *
 * @returns {boolean}
 */
export const isSysop = () => {
    const isSysop = localStorage.getItem('sys_op');
    return isSysop === 'true';
};

/**
 * Determine if user is sysop or sysadmin
 *
 * @returns {boolean}
 */
export const isSysopOrSysadmin = () => {
    const isSysop = localStorage.getItem('sys_op');
    const isSysadmin = localStorage.getItem('sys_admin');
    return isSysop === 'true' || isSysadmin === 'true';
};

/**
 * Determine if user has access to a section or all sections
 *
 * @param section
 * @returns {boolean}
 */
export const hasSectionAccess = (section) => {
    const sectionsAll = localStorage.getItem('sections_all');
    if (sectionsAll === 'true') {
        return true;
    }
    const userSections = JSON.parse(localStorage.getItem('sections'));
    if (userSections && userSections.includes(section)) {
        return true;
    }
    return false;
};

/**
 * Determine if user has access to a system or all systems
 *
 * @param system
 * @returns {boolean}
 */
export const hasSystemAccess = (system) => {
    const systemsAll = localStorage.getItem('systems_all');
    if (systemsAll === 'true') {
        return true;
    }
    const userSystems = JSON.parse(localStorage.getItem('systems'));
    if (userSystems && userSystems.includes(system)) {
        return true;
    }
    return false;
};



// WEBPACK FOOTER //
// ./src/Fuse/shared/authFunctions.js